import { render, staticRenderFns } from "./ApparelSelector.vue?vue&type=template&id=6d7239a6&scoped=true&"
import script from "./ApparelSelector.vue?vue&type=script&lang=js&"
export * from "./ApparelSelector.vue?vue&type=script&lang=js&"
import style0 from "./ApparelSelector.vue?vue&type=style&index=0&id=6d7239a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7239a6",
  null
  
)

export default component.exports